import { PropsWithChildren } from 'react'

import { CrossIcon } from '../../assets/icons'
import { PrimaryButton } from '../PrimaryButton'
import { SecundaryButton } from '../SecundaryButton'
import './styles.css'

interface Props {
  title: string
  open: boolean
  onClose: () => void
  showActionButtons?: boolean
  onSave?: () => void
  disabledSave?: boolean
  maxWidth?: string
  width?: string
}

const Modal = ({
  title,
  open,
  onClose,
  showActionButtons,
  onSave,
  disabledSave,
  children,
  maxWidth,
  width,
}: PropsWithChildren<Props>) => {
  return (
    <div id="modalWrapper" className={`${open ? 'visible' : ''}`}>
      <div className="modal-content" style={maxWidth && width ? { maxWidth, width } : {}}>
        <div onClick={() => onClose()} className="modal__close" id="modalClose">
          <CrossIcon />
        </div>
        <p className="modal-content__success-msg" id="msg">
          {title}
        </p>
        {children}
        {showActionButtons && (
          <div className="button-container">
            <SecundaryButton label="Cancelar" onClick={() => onClose()} />
            <PrimaryButton
              label="Guardar"
              onClick={() => onSave && onSave()}
              disabled={disabledSave}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export { Modal }
